/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import { NodeSelection, TextSelection, Transaction, EditorState } from "prosemirror-state";
import { ItsmanWindow } from "containers/page/page";
import { get } from "lodash";
import { getReduxActionLog } from "utils";

const w = (window as unknown) as ItsmanWindow;

export function safeTextSelection(doc, anchor, head?): TextSelection {
  try {
    return TextSelection.create(doc, anchor, head ? head : anchor);
  } catch (e) {
    const contentSize = get(doc, ["content", "size"]);
    w.newrelic.noticeError(e, {
      errorType: "invalid_text_selection",
      errorDescription: "The text selection is out of range",
      errorInfo: JSON.stringify({ anchor, head, contentSize }),
      reduxActionLog: JSON.stringify({ actions: getReduxActionLog() })
    });
    return TextSelection.create(doc, contentSize || 0);
  }
}

export function setTextSelection(tr: Transaction, editorState: EditorState, pos: number): Transaction {
  return tr.setSelection(safeTextSelection(editorState.doc, pos));
}

export function setTextSelectionToDocumentEnd(tr: Transaction, editorState: EditorState): Transaction {
  const docSize = get(editorState.doc, ["content", "size"]);
  return tr.setSelection(safeTextSelection(editorState.doc, docSize));
}

export function setTextSelectionFromTransaction(tr: Transaction, from: number, to: number = from): Transaction {
  return tr.setSelection(safeTextSelection(tr.doc, from, to));
}

export function setNodeSelection(tr: Transaction, editorState: EditorState, pos: number): Transaction {
  tr.setSelection(NodeSelection.create(editorState.doc, pos));
  return tr;
}
